import React from 'react';
import { BannerProps, money } from './BannerProps';

/**
 * Design 9: was / now. Two numbers, nothing else — best when the saving
 * is large. Owner-approved mockup #09.
 */
const LadderBanner: React.FC<BannerProps> = ({ promotion, brandColor = '#1e5aa8' }) => {
  const now = promotion.totalCents ?? 0;
  const was = promotion.wasTotalCents;
  const saving = was !== null ? Math.max(0, was - now) : null;

  return (
    <div
      style={{
        background: '#fff',
        color: '#111',
        fontFamily: 'Helvetica, Arial, sans-serif',
        borderRadius: 6,
        padding: '12px 14px',
        maxWidth: '100%',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        flexWrap: 'wrap',
      }}
    >
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 11, letterSpacing: '0.12em', color: brandColor, fontWeight: 700, textTransform: 'uppercase' }}>
          {promotion.headline ?? promotion.name}
        </div>
        {promotion.body && (
          <div style={{ fontSize: 12, color: '#5b6470', marginTop: 3, overflowWrap: 'break-word' }}>{promotion.body}</div>
        )}
      </div>
      <div style={{ textAlign: 'right' }}>
        {was !== null && (
          <div style={{ fontSize: 15, color: '#9aa2ac', textDecoration: 'line-through' }}>{money(was)}</div>
        )}
        <div style={{ fontSize: 26, fontWeight: 800, color: '#15803d', lineHeight: 1 }}>{money(now)}</div>
        {saving !== null && (
          <span
            style={{
              display: 'inline-block',
              marginTop: 4,
              borderRadius: 999,
              padding: '2px 10px',
              fontSize: 11,
              fontWeight: 700,
              background: '#dcfce7',
              color: '#15803d',
            }}
          >
            SAVE {money(saving)}
          </span>
        )}
      </div>
    </div>
  );
};

export default LadderBanner;
